import { useCallback, useContext } from "react";
import AppContext from "../contexts/AppContext";
import { useLocalStorage } from "./LocalStorage";
//let keys: string = '';
export const UseTranslate = () => {
  const { keywords, selectedLanguage } = useContext(AppContext);
  const [storedLanguage] = useLocalStorage("language", "");

  const translate = useCallback(
    (key: string) => {
      if (keywords && keywords.length) {
        const keyword = keywords?.find((keyword) => keyword.key === key);
        if (keyword) {
          const lang = Object.keys(selectedLanguage as object).length
            ? selectedLanguage
            : storedLanguage;
          const translation = keyword.translations
            ? keyword.translations[lang ? lang.key : 'ge']
            : undefined;
          return translation ? translation : key;
        }
        //console.log(key);
        return key;
      }
      return "";
    },
    [keywords, storedLanguage, selectedLanguage]
  );

  return [translate];
};
